import { render, staticRenderFns } from "./PaymentTransactionsTable.vue?vue&type=template&id=4c746e9d"
import script from "./PaymentTransactionsTable.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionsTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentTransactionsTable.vue?vue&type=style&index=0&id=4c746e9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports